import { RolloutProgressReportEntities } from '../../../../shared/self-inspection-reports/service/entities';
import { SpanColorGuideData } from './span-color-guide.component';

export const spanColorGuideDataMultiSpan: SpanColorGuideData[] = [
  {
    hexCode: RolloutProgressReportEntities.v3.SpanColor.SELECTED,
    colorName: 'selectSpanMode.helpModal.spanColorGuide.colorNames.cyan',
    description:
      'selectSpanMode.helpModal.spanColorGuide.description.' +
      RolloutProgressReportEntities.v3.SpanStaus.SELECTED,
  },
  {
    hexCode: RolloutProgressReportEntities.v3.SpanColor.PLANNED,
    colorName: 'selectSpanMode.helpModal.spanColorGuide.colorNames.black',
    description:
      'selectSpanMode.helpModal.spanColorGuide.description.' +
      RolloutProgressReportEntities.v3.SpanStaus.PLANNED,
  },
  {
    hexCode: RolloutProgressReportEntities.v3.SpanColor.IN_PROGRESS,
    colorName: 'selectSpanMode.helpModal.spanColorGuide.colorNames.purple',
    description:
      'selectSpanMode.helpModal.spanColorGuide.description.' +
      RolloutProgressReportEntities.v3.SpanStaus.IN_PROGRESS,
  },
  {
    hexCode: RolloutProgressReportEntities.v3.SpanColor.DONE,
    colorName: 'selectSpanMode.helpModal.spanColorGuide.colorNames.green',
    description:
      'selectSpanMode.helpModal.spanColorGuide.description.' +
      RolloutProgressReportEntities.v3.SpanStaus.DONE,
  },
  {
    hexCode: RolloutProgressReportEntities.v3.SpanColor.RESTORED,
    colorName: 'selectSpanMode.helpModal.spanColorGuide.colorNames.darkGreen',
    description:
      'selectSpanMode.helpModal.spanColorGuide.description.' +
      RolloutProgressReportEntities.v3.SpanStaus.RESTORED,
  },
  {
    hexCode: RolloutProgressReportEntities.v3.SpanColor.DEVIATED,
    colorName: 'selectSpanMode.helpModal.spanColorGuide.colorNames.red',
    description:
      'selectSpanMode.helpModal.spanColorGuide.description.' +
      RolloutProgressReportEntities.v3.SpanStaus.DEVIATED,
  },
];
